import {Injectable} from '@angular/core';

@Injectable({
    providedIn: "root"
})

export class PrepareHtmlForExport {
    constructor() {}

   getPage(printSection: string, styles: string){
    return `
      <html>
        <head>
          <title>Print tab</title>
          <style>
            ${styles}
          </style>
        </head>
        <body onload=PRINT_CONTENT>
          ${printSection}
        </body>
      </html>
    `;
   }
   
   getPageForEmail(printSection: string, styles: string){
    return `
      <html>
        <head>
          <title>Receipt</title>
          <style>
            ${styles}
          </style>
        </head>
        <body>
        ${printSection}
      </body>
      </html>
    `;
   }
}
